import type { User } from '@barboxx/models/types';

import { api } from '../api';

const rootPath = 'users';

export function getUsers(query: User.SearchQueryModel) {
    return api.get<User.SearchResponse>(rootPath, query);
}

export function getUser(id: number) {
    return api.get<User>(`${rootPath}/${id}`);
}

export function updateUser(id: number, data: User.UpdateRequest) {
    return api.put<User>(`${rootPath}/${id}`, data);
}

export function updatePassword(data: User.UpdatePasswordRequest) {
    return api.put<User>(`${rootPath}/password`, data);
}

export function createUser(data: User.CreateRequest) {
    return api.post<User>(`${rootPath}/`, data);
}

export function invalidateTokens() {
    return api.delete<{ message: string }>(`${rootPath}/tokens`);
}

export function deleteById(id: number) {
    return api.delete<User>(`${rootPath}/${id}`);
}
